import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {MaterialModule} from "./utils/material.module";
import {BuildRequestInterceptor} from "./interceptors/build-request.interceptor";
import {AppTranslateModule} from "./utils/app-translate.module";
import {IConfig, NgxMaskModule} from "ngx-mask";
import {TranslationInitService} from "./services/translation-init.service";
import {TokenService} from "./services/token.service";
import * as Sentry from "@sentry/angular";
import {Router} from "@angular/router";
import {SentryErrorHandlerService} from "./services/sentry-error-handler.service";

export const options: Partial<null|IConfig> | (() => Partial<IConfig>) = null;

export function appInitializerFactory(translateInitService: TranslationInitService, tokenService: TokenService) {
  // tokenService.driverAppId.next('747174e2-fca7-42ba-b9ac-262bb9b137f2');
  tokenService.driverAppId.next(
    new URLSearchParams(
      new URL(
        location.toString().replace('#/', '')).search)
      .get('application_id'));
  tokenService.fireBaseToken$.next(
    new URLSearchParams(
      new URL(
        location.toString().replace('#/', '')).search)
      .get('fmc'));
  return () => translateInitService.initTranslation();
}


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    AppTranslateModule,
    NgxMaskModule.forRoot()
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslationInitService, TokenService, Sentry.TraceService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BuildRequestInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandlerService,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
